import { Col, Row } from "@/utils/bootstrap";
import { ISearchProduct } from "@/api/AppApi/services/product/interfaces/api-product-interfaces";
import HighlightText from "./HighlightText";
import Price from "@/app/components/lib/Price";
import NextImage from "@/app/components/lib/NextImage";

interface Props {
  product: ISearchProduct;
  searchTerm: string;
}

const SearchResultItem: React.FC<Props> = ({ product, searchTerm }) => {
  return (
    <Row className="m-0 align-items-center" style={{ gap: 8 }}>
      <Col className="p-0 col-3 d-flex align-items-center">
        <div className="product-image" style={{ width: 48, height: 48 }}>
          <NextImage
            alt={product?.name}
            src={product?.thumbnail_url}
            objectFit="fill"
          />
        </div>
      </Col>
      <Col className="p-0 col-8">
        <Row className="m-0 product-name">
          <HighlightText
            text={product?.name}
            highlight={searchTerm}
            highlightClass="highlight"
          />
        </Row>
        <Price
          price={{ value: product.price, className: "product-price" }}
          priceWithoutDiscount={{
            value: product.price_without_discount,
            className: "product-old-price",
          }}
          roundPrice
        />
      </Col>
    </Row>
  );
};

export default SearchResultItem;
